import { render } from "./BoxListingHover.vue?vue&type=template&id=2921fb39"
import script from "./BoxListingHover.vue?vue&type=script&lang=js"
export * from "./BoxListingHover.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__